import axios from 'axios';
import { GetTokenRequest, GetTokenResponse, GetTokenWithWebIdRequest } from '../schemas';

export async function post(body: GetTokenRequest) {
    return axios.post<GetTokenResponse>('/v1/token', body, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export async function getTokenWithWebId(body: GetTokenWithWebIdRequest) {
    return axios.post<GetTokenResponse>('v1/token-with-web-id', body, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}
